import React, { useState } from "react";
import ThreeDotsIcon from "../Assets/Icons/threeDots.svg";
import AvatarGroup from "./AvatarGroup";
import AssignProjectModal from "./AssignProjectModal";
import EyeIcon from "../Assets/Icons/eyeBlack.svg";

export default function SuccessTeamCard(props) {
  const [openModal, setOpenModal] = useState(false);
  return (
    <div>
      <AssignProjectModal open={openModal} setOpen={setOpenModal} />
      <div className="w-[18rem] py-4 px-4 border-[1px] bg-white rounded-[12px] border-[#E5E7EB]">
        <div className="flex items-center justify-end gap-3">
          <img src={EyeIcon} />
          {/* <img src={ThreeDotsIcon} /> */}
        </div>
        <div>
          <img src={props.teamimg} />
        </div>
        <div className="flex flex-col gap-[2px] mt-[8px]">
          <h2 className="text-[1.1rem] font-[500] text-[#111928]">
            {props.teamname}
          </h2>
          <p className="text-[0.90rem] text-[#6B7280]">{props.text}</p>
        </div>
        <div className="flex flex-col gap-1 mt-3">
          <p className="text-[0.90rem] text-[#6B7280]">Team members</p>
          <AvatarGroup />
        </div>
        <p className="text-[0.90rem] text-[#6B7280] font-[500] mt-2">
          Assigned AI Project{" "}
          <span className="text-[#942A27]">{props.projectname}</span>
        </p>
        <button
          className="w-full h-[2.3rem] text-[0.90rem] text-white bg-[#942A27] rounded-[8px] mt-3"
          onClick={() => setOpenModal(true)}
        >
          Assign Project
        </button>
      </div>
    </div>
  );
}
